import {
    onMount,
    onCleanup,
    splitProps,
    mergeProps,
} from 'solid-js'
import CustomSVG from '../../atoms/custom-svg.jsx'

export function useBannerMoleculeComponentController (props) {
    const defaultProps = {
        autoDismissTimer: null,
        body: '',
        buttons: null,
        class: '',
        header: '',
        hideIcon: false,
        icon: null,
        inlineAction: null,
        inlineActionText: '',
        layout: 'stacked',
        onClose: () => {},
        onInlineActionClick: null,
        variant: 'default',
    }

    const mergedProps = mergeProps(defaultProps, props)
    const [
        _,
        styles,
        forwardedProps,
    ] = splitProps(mergedProps, [], ['class'])

    const iconMap = {
        default: 'icons/info-outlined',
        'outlined-muted': 'icons/info-outlined',
        'outlined-neutral': 'icons/info-outlined',
        'outlined-success': 'icons/info-outlined--green',
        success: 'icons/checkmark-circled-filled',
        warning: 'icons/alert-triangle-filled',
    }

    const icon = () => {
        if (mergedProps.icon) return mergedProps.icon
        return <CustomSVG path={iconMap[mergedProps.variant] || iconMap.default} />
    }

    const hasInlineAction = () =>
        mergedProps.layout === 'inline' && (
            mergedProps.inlineAction || mergedProps.inlineActionText
        )

    const rootClass = () => [
        'banner-molecule-component',
        mergedProps.layout ? `banner-molecule-component--${mergedProps.layout}` : '',
        hasInlineAction()
            ? 'banner-molecule-component--inline-action'
            : (mergedProps.layout === 'inline'
                ? 'banner-molecule-component--inline-no-action'
                : ''),
        `banner-molecule-component--${mergedProps.variant}`,
        styles.class || '',
    ].filter(Boolean).join(' ')

    const shouldHideCloseButton = () =>
        mergedProps.hideCloseButton ?? (
            mergedProps.variant === 'outlined-success' && mergedProps.layout === 'inline'
        )

    const remaining = mergedProps.autoDismissTimer
    let timeoutId
    let startTime
    let elapsed = 0

    const clear = () => clearTimeout(timeoutId)
    const startTimer = () => {
        if (!remaining) return
        startTime = Date.now()
        timeoutId = setTimeout(() => {
            mergedProps.onClose?.()
        }, remaining - elapsed)
    }

    const pauseTimer = () => {
        clear()
        elapsed += Date.now() - startTime
    }

    const resumeTimer = () => {
        startTimer()
    }

    onMount(() => {
        if (remaining) startTimer()
        onCleanup(() => clear())
    })

    return {
        forwardedProps,
        icon,
        mergedProps,
        pauseTimer,
        resumeTimer,
        rootClass,
        shouldHideCloseButton,
    }
}
